<template>
  <div >
    <el-select
      v-model="selected_admin"
      :placeholder="placeholder"
      value-key="admin_id"
      filterable
      remote
      :remote-method="getadmin"
      clearable
      @change="changeadmin"
      ref="agentSelect"
      @hook:mounted="cancalReadOnly"
      @visible-change="cancalReadOnly"
      :focus-onec="getadmin"
    >
      <el-option
        v-for="item in admin_list"
        :key="item.id"
        :label="item.name"
        :value="item.id"
        @click.native="adminChnage(item)"
      >
      </el-option>
    </el-select>
  </div>
</template>
  
  <script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "请输入登录账号",
    },
    info:{
       type: String,
      default: "",
    },
    condition:{
       type: Object,
      default: () => {},
    },
  },
  watch:{
    info:{
      immediate:true,
      handler(nv,ov){
        if(nv){
          this.selected_admin = nv
        }
      }
    }
  },
  data() {
    return {
      admin_list: [],
      selected_admin: "",
    };
  },
  methods: {
    changeadmin() {
      this.$emit("update:adminid", this.selected_admin);
    },
    adminChnage(item) {
      this.$emit("change", item);
    },
    getadmin(query) {
      this.admin_list = [];
      if (query && typeof query == "string") {
        let data = {
          ...this.condition
          // type:'consultant'
        };
        data.login_name = query
        let url = "/authorization/managerUser/queryListPage";
        this.$axios
          .get(url, {
            params: data,
          })
          .then((res) => {
            this.admin_list = res.data.data;
            this.$emit("search", res.data.data);
          });
      }
    },
    clear() {
      this.admin_list = [];
      this.selected_admin = "";
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const Selects = this.$refs;

          if (Selects.agentSelect) {
            const input =
              Selects.agentSelect.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>